import { queryOptions } from '@tanstack/react-query';
import * as adminApi from '../endpoints/admin';
import { ListPendingMenuItemsParams, ListPendingBusinessesParams, PaginatedBusinessResponse } from '../endpoints/admin';
import type { ListInvitesParams } from '../endpoints/admin-invites';
import { PaginatedMenuItemResponse } from '../endpoints/menu-items';

/**
 * Query keys for admin operations
 */
export const ADMIN_QUERY_KEYS = {
  all: ['admin'] as const,
  users: () => [...ADMIN_QUERY_KEYS.all, 'users'] as const,
  pendingMenuItems: () => [...ADMIN_QUERY_KEYS.all, 'pending-menu-items'] as const,
  pendingMenuItemsList: (params: ListPendingMenuItemsParams) =>
    [...ADMIN_QUERY_KEYS.pendingMenuItems(), params] as const,
  pendingBusinesses: () => [...ADMIN_QUERY_KEYS.all, 'pending-businesses'] as const,
  pendingBusinessesList: (params: ListPendingBusinessesParams) =>
    [...ADMIN_QUERY_KEYS.pendingBusinesses(), params] as const,
  invites: () => [...ADMIN_QUERY_KEYS.all, 'invites'] as const,
  invitesList: (params: ListInvitesParams) =>
    [...ADMIN_QUERY_KEYS.invites(), params] as const,
  inviteStats: () => [...ADMIN_QUERY_KEYS.all, 'invite-stats'] as const,
} as const;

/**
 * Query options for listing pending menu items
 */
export const pendingMenuItemsQueryOptions = (params: ListPendingMenuItemsParams = {}) =>
  queryOptions({
    queryKey: ADMIN_QUERY_KEYS.pendingMenuItemsList(params),
    queryFn: async (): Promise<PaginatedMenuItemResponse> => {
      return adminApi.listPendingMenuItems(params);
    },
    staleTime: 1000 * 60 * 2, // 2 minutes - admin data should be fresh
    gcTime: 1000 * 60 * 10, // 10 minutes
    meta: {
      persist: false,
    },
  });

/**
 * Query options for listing pending businesses
 */
export const pendingBusinessesQueryOptions = (params: ListPendingBusinessesParams = {}) =>
  queryOptions({
    queryKey: ADMIN_QUERY_KEYS.pendingBusinessesList(params),
    queryFn: async (): Promise<PaginatedBusinessResponse> => {
      return adminApi.listPendingBusinesses(params);
    },
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    meta: {
      persist: false,
    },
  });
